export default __webpack_public_path__ + "static/iconography-image-m-6ed02182a18f0e2a3726e3cf608365f8.png";